import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import UserProfileMenu from './UserProfileMenu';
import SearchInterface from './SearchInterface';
import { useAuth } from '../../contexts/AuthContext';
import AlertDropdown from '../AlertDropdown';

const TopNavigationBar = () => {
  const location = useLocation();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { userProfile } = useAuth();

  const navigationItems = [
    { label: 'Home', path: '/homepage', icon: 'Home' },
    { label: 'Feed', path: '/personalised-feed', icon: 'BookOpen' },
    { label: 'Topics', path: '/topic-browse', icon: 'Tag' },
    { label: 'Write', path: '/story-editor', icon: 'PenTool' },
    { label: 'Reading List', path: '/reading-list', icon: 'Bookmark' },
    { label: 'Analytics', path: '/analytics-dashboard', icon: 'BarChart3', adminOnly: true },
    { label: 'Developer', path: '/developer-dashboard', icon: 'Code', adminOnly: true },
  ];

  const adminLinks = [
    { label: 'Admin Dashboard', path: '/admin-dashboard', icon: 'Shield' },
    { label: 'Admin Settings', path: '/admin-settings', icon: 'Settings' },
    { label: 'Admin Notifications', path: '/admin-notifications', icon: 'Bell' },
    { label: 'Alert History', path: '/admin-alerts', icon: 'Bell' },
    { label: 'Analytics', path: '/analytics-dashboard', icon: 'BarChart3' },
    { label: 'Developer', path: '/developer-dashboard', icon: 'Code' }
  ];

  const isActive = (path) => location?.pathname === path;

  // Filter navigation items based on user role
  const userRole = userProfile?.role || 'reader';
  const visibleNavItems = navigationItems?.filter(item => {
    if (item?.adminOnly) {
      return userRole === 'admin';
    }
    return true;
  });

  return (
    <>
      <nav className="bg-[#F5F3FF] border-b sticky top-0 z-50 shadow-sm" style={{ borderColor: 'rgba(155, 141, 199, 0.2)' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/homepage" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #9B8DC7 0%, #D4A574 100%)' }}>
                <Icon name="Feather" size={24} color="#FFFFFF" />
              </div>
              <span className="text-2xl font-display font-bold text-charcoal">Quilline</span>
            </Link>

            <div className="hidden lg:flex items-center gap-1">
              {userRole === 'admin' && (
                <Link
                  to="/admin-dashboard"
                  className={`px-4 py-2 rounded-lg font-sans font-medium transition-all duration-250 ${
                    isActive('/admin-dashboard')
                      ? 'bg-[#9B8DC7] text-white' :'text-charcoal hover:bg-[#9B8DC7]/10'
                  }`}
                >
                  Admin
                </Link>
              )}
              {visibleNavItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`px-4 py-2 rounded-lg font-sans font-medium transition-all duration-250 ${
                    isActive(item?.path)
                      ? 'bg-[#9B8DC7] text-white' :'text-charcoal hover:bg-[#9B8DC7]/10'
                  }`}
                >
                  {item?.label}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={() => setIsSearchOpen(true)}
                className="hidden md:flex items-center gap-2 bg-white border rounded-full px-4 py-2 transition-colors duration-250 hover:border-[#9B8DC7]"
                style={{ borderColor: 'rgba(155, 141, 199, 0.2)' }}
                aria-label="Search stories"
              >
                <Icon name="Search" size={20} color="#9B8DC7" />
                <input
                  type="text"
                  placeholder="Search stories, writers, topics..."
                  readOnly
                  className="cursor-pointer bg-transparent border-none outline-none text-sm font-sans text-muted-foreground w-48"
                />
              </button>

              <button
                onClick={() => setIsSearchOpen(true)}
                className="md:hidden p-2 rounded-lg transition-colors duration-250 hover:bg-[#9B8DC7]/10"
                aria-label="Open search"
              >
                <Icon name="Search" size={24} color="#9B8DC7" />
              </button>

              <AlertDropdown />

              <UserProfileMenu />
            </div>
          </div>
        </div>
      </nav>
      {isSearchOpen && (
        <SearchInterface onClose={() => setIsSearchOpen(false)} />
      )}
    </>
  );
};

export default TopNavigationBar;